
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TableButton extends Vue {
  @Prop(String) readonly buttonText!: string;
  @Prop(String) readonly buttonIcon!: string;
  @Prop(String) readonly buttonClassName!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
}
